import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const WEB_FUNNEL_DOMAIN = "web-funnel";

export const WEB_FUNNEL_BEGIN = "begin";

export interface WebFunnelBeginResultType {
  testType: string;
}

export const webFunnelApi = {
  begin: (mixpanelDistinctId: string, testType?: string) =>
    axiosInstance.post<CustomResponseFormat<WebFunnelBeginResultType>>(
      `${WEB_FUNNEL_DOMAIN}/${WEB_FUNNEL_BEGIN}`,
      { clientId: mixpanelDistinctId, testType: testType, version: "v4" }
    ),
};
